import styles from './InspirationList.module.scss'
import InspirationItem from './InspirationItem'

export default function InspirationList({ items }) {
  if (!items || items.length === 0) return null
  return (
    <div className={styles.list}>
      {items.map((item) => (
        <InspirationItem {...item} key={item.slug} />
      ))}
    </div>
  )
}
